import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "seq-dashboard-profile-sticky" }
const _hoisted_2 = { class: "card seq-card seq-dashboard-profile" }
const _hoisted_3 = { class: "seq-dashboard-profile__cover" }
const _hoisted_4 = { class: "seq-dashboard-profile__body" }
const _hoisted_5 = { class: "seq-dashboard-profile__main" }
const _hoisted_6 = { class: "seq-dashboard-profile__avatar-wrap" }
const _hoisted_7 = { class: "seq-dashboard-profile__content" }
const _hoisted_8 = { class: "seq-dashboard-profile__name-row" }
const _hoisted_9 = { class: "seq-dashboard-profile__name-group" }
const _hoisted_10 = { class: "seq-dashboard-profile__name" }
const _hoisted_11 = { class: "svg-icon svg-icon-1 svg-icon-primary" }
const _hoisted_12 = {
  key: 0,
  class: "seq-dashboard-profile__achievements seq-dashboard-profile__achievements--desktop"
}
const _hoisted_13 = { class: "seq-dashboard-profile__id-row" }
const _hoisted_14 = {
  key: 0,
  class: "seq-dashboard-profile__bio"
}
const _hoisted_15 = { class: "seq-dashboard-profile__badges seq-dashboard-profile__badges--mobile" }
const _hoisted_16 = {
  class: "seq-dashboard-profile__menu",
  ref: "menuRoot"
}
const _hoisted_17 = /*#__PURE__*/_createVNode("i", { class: "bi bi-three-dots" }, null, -1)
const _hoisted_18 = {
  key: 0,
  class: "seq-dashboard-profile__dropdown"
}
const _hoisted_19 = /*#__PURE__*/_createTextVNode(" View Profile ")
const _hoisted_20 = {
  key: 0,
  class: "seq-dashboard-profile__achievements seq-dashboard-profile__achievements--mobile"
}
const _hoisted_21 = /*#__PURE__*/_createVNode("div", { class: "seq-dashboard-profile__meta" }, null, -1)
const _hoisted_22 = {
  key: 0,
  class: "seq-dashboard-profile__lifetime"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")
  const _component_router_link = _resolveComponent("router-link")
  const _component_HeroBalanceCard = _resolveComponent("HeroBalanceCard")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _createVNode("img", {
          src: _ctx.coverPhoto,
          alt: "",
          class: "seq-dashboard-profile__cover-img"
        }, null, 8, ["src"])
      ]),
      _createVNode("div", _hoisted_4, [
        _createVNode("div", _hoisted_5, [
          _createVNode("div", _hoisted_6, [
            _createVNode("img", {
              src: _ctx.user.avatar,
              alt: _ctx.avatarAlt,
              class: "seq-dashboard-profile__avatar"
            }, null, 8, ["src", "alt"]),
            (_ctx.showRankImage && _ctx.rankPrimeImage)
              ? (_openBlock(), _createBlock("img", {
                  key: 0,
                  src: _ctx.cacheBust(_ctx.rankPrimeImage),
                  alt: "Rank badge",
                  class: "seq-dashboard-profile__rank"
                }, null, 8, ["src"]))
              : _createCommentVNode("", true),
            (_ctx.axxpLvlImg)
              ? (_openBlock(), _createBlock("img", {
                  key: 1,
                  src: _ctx.cacheBust(_ctx.axxpLvlImg),
                  alt: "AXXP Level Badge",
                  class: "seq-dashboard-profile__axxp"
                }, null, 8, ["src"]))
              : _createCommentVNode("", true)
          ]),
          _createVNode("div", _hoisted_7, [
            _createVNode("div", _hoisted_8, [
              _createVNode("div", _hoisted_9, [
                _createVNode("h2", _hoisted_10, _toDisplayString(_ctx.user.fname) + " " + _toDisplayString(_ctx.user.lname), 1),
                _createVNode("span", _hoisted_11, [
                  _createVNode(_component_inline_svg, { src: "media/icons/duotone/Design/Verified.svg" })
                ])
              ]),
              (_ctx.displayAchievements.length)
                ? (_openBlock(), _createBlock("div", _hoisted_12, [
                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.displayAchievements, (achievement, index) => {
                      return (_openBlock(), _createBlock("span", {
                        key: 'd-' + index,
                        class: "seq-dashboard-profile__achievement"
                      }, _toDisplayString(achievement), 1))
                    }), 128))
                  ]))
                : _createCommentVNode("", true)
            ]),
            _createVNode("div", _hoisted_13, [
              (_ctx.displayBio)
                ? (_openBlock(), _createBlock("p", _hoisted_14, _toDisplayString(_ctx.displayBio), 1))
                : _createCommentVNode("", true),
              _createVNode("div", _hoisted_15, [
                (_ctx.showRankImage && _ctx.rankPrimeImage)
                  ? (_openBlock(), _createBlock("img", {
                      key: 0,
                      src: _ctx.cacheBust(_ctx.rankPrimeImage),
                      alt: "Rank badge",
                      class: "seq-dashboard-profile__rank"
                    }, null, 8, ["src"]))
                  : _createCommentVNode("", true),
                (_ctx.axxpLvlImg)
                  ? (_openBlock(), _createBlock("img", {
                      key: 1,
                      src: _ctx.cacheBust(_ctx.axxpLvlImg),
                      alt: "AXXP Level Badge",
                      class: "seq-dashboard-profile__axxp"
                    }, null, 8, ["src"]))
                  : _createCommentVNode("", true)
              ]),
              _createVNode("div", _hoisted_16, [
                _createVNode("button", {
                  type: "button",
                  class: "seq-dashboard-profile__menu-btn",
                  "aria-label": "Profile actions",
                  onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.toggleMenu && _ctx.toggleMenu(...args)))
                }, [
                  _hoisted_17
                ]),
                (_ctx.menuOpen)
                  ? (_openBlock(), _createBlock("div", _hoisted_18, [
                      (_ctx.profileRoute)
                        ? (_openBlock(), _createBlock(_component_router_link, {
                            key: 0,
                            to: _ctx.profileRoute,
                            class: "seq-dashboard-profile__dropdown-item",
                            onClick: _ctx.closeMenu
                          }, {
                            default: _withCtx(() => [
                              _hoisted_19
                            ]),
                            _: 1
                          }, 8, ["to", "onClick"]))
                        : _createCommentVNode("", true),
                      (_ctx.showAddAccount)
                        ? (_openBlock(), _createBlock("button", {
                            key: 1,
                            type: "button",
                            class: "seq-dashboard-profile__dropdown-item",
                            onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.onAddAccount && _ctx.onAddAccount(...args)))
                          }, " Add OVI Account "))
                        : _createCommentVNode("", true),
                      _createVNode("button", {
                        type: "button",
                        class: "seq-dashboard-profile__dropdown-close",
                        onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.closeMenu && _ctx.closeMenu(...args)))
                      }, " Close ")
                    ]))
                  : _createCommentVNode("", true)
              ], 512)
            ]),
            (_ctx.displayAchievements.length)
              ? (_openBlock(), _createBlock("div", _hoisted_20, [
                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.displayAchievements, (achievement, index) => {
                    return (_openBlock(), _createBlock("span", {
                      key: 'm-' + index,
                      class: "seq-dashboard-profile__achievement"
                    }, _toDisplayString(achievement), 1))
                  }), 128))
                ]))
              : _createCommentVNode("", true),
            _hoisted_21
          ]),
          (_ctx.showLifetimeIncome)
            ? (_openBlock(), _createBlock("div", _hoisted_22, [
                _createVNode(_component_HeroBalanceCard, {
                  label: _ctx.lifetimeLabel,
                  amount: _ctx.lifetimeAmount,
                  currencySymbol: _ctx.lifetimeCurrency
                }, null, 8, ["label", "amount", "currencySymbol"])
              ]))
            : _createCommentVNode("", true)
        ])
      ])
    ])
  ]))
}